import React, { useState } from 'react';
import { Field, Form, Formik } from 'formik';
import qs from 'qs';
import { contactFormValidation } from '../validations';
import { Alert } from '../../CommonComponents/Alert/Alert';
import useApi from '../../_hooks/useApi';
import Modal from '../../CommonComponents/Modal';

interface ConsumerDetails {
  CurrentAge: string;
  SpouseCurrentAge: string;
  HouseholdIncome: string;
  MonthlyExpense: string;
  MonthlyRetirementSavings: string;
  TotalRetirementSavings: string;
  RetirementAge: string;
  SpouseRetirementAge: string;
}

interface Props {
  consumerDetails: ConsumerDetails;
  isOpen: boolean;
  onRequestClose: () => void;
}

const ContactModal: React.FC<Props> = ({ consumerDetails, isOpen, onRequestClose }) => {
  const [isContactSent, setIsContactSent] = useState(false);
  const [sendContact, { loading }] = useApi('/guest/ExpressWizardRetirement/SendCta', {
    method: 'POST',
  });

  const { ctaemail: ctaEmail } = qs.parse(document.location.search.toLowerCase(), {
    ignoreQueryPrefix: true,
  });

  if (isContactSent) {
    return (
      <Modal isOpen={isOpen} onRequestClose={onRequestClose}>
        <div style={{ padding: '40px' }}>
          <p>Thank you! An advisor will contact you soon.</p>
          <div className="actions">
            <button type="button" onClick={onRequestClose}>
              OK
            </button>
          </div>
        </div>
      </Modal>
    );
  }

  return (
    <Modal className="modal" isOpen={isOpen} onRequestClose={onRequestClose}>
      <Formik
        initialValues={{
          Name: '',
          Email: '',
          Phone: '',
          ctaEmail,
        }}
        validationSchema={contactFormValidation}
        onSubmit={value => {
          sendContact({
            body: {
              ...value,
              ...consumerDetails,
            },
            onSuccess: () => {
              setIsContactSent(true);
            },
          });
        }}
      >
        {({ errors, touched }) => {
          return (
            <div className="closerdiv" style={{ paddingTop: '50px' }}>
              <div id="ExpressWizard_CTA" className="popup" style={{ display: 'block' }}>
                <h2>
                  <i className="fa fa-times close" onClick={onRequestClose} />
                </h2>

                {Object.keys(errors).length > 0 && Object.keys(touched).length > 0 && (
                  <Alert message="Name and Email are required fields" />
                )}

                <Form className="adv-form">
                  <ul>
                    <li>
                      <Field type="text" name="Name" placeholder="Name" />
                    </li>
                    <li>
                      <Field type="text" name="Email" placeholder="Your Email Address" />
                    </li>
                    <li>
                      <Field type="text" name="Phone" placeholder="Your Phone Number" />
                    </li>
                  </ul>

                  <div className="actions">
                    <button type="submit" id="btn-save" className={`${loading ? 'loading' : ''}`}>
                      Next
                    </button>
                  </div>
                </Form>
              </div>
            </div>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default ContactModal;
